import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import HubDetails from './components/HubDetails';
import PndApi from '../../../../utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import { showNotification } from 'src/shared/components/Notification';
import DomainIcon from '@mui/icons-material/Domain';
import { Box } from '@mui/material';
import PageHeader from 'src/shared/components/layout/PageHeader';

const HubDetailsIndex = () => {
  useEffect(() => {
    getAllHubDetails();
  }, []);
  const [reactTableData, setReactTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const getAllHubDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllHubDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data?.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<DomainIcon fontSize="large" />}
          title="Hub Management"
          subtitle="View all hub details, locations and operations."
          gradient="linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"
        />
   
        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <HubDetails reactTableData={reactTableData} />}
          {loading && <LinearProgress color="primary" />}
          {isNoRecordFound && <HubDetails isNoRecordFound={isNoRecordFound} />}
          {/* {isNoRecordFound && <SnackbarContent message={'No Record Found'} />} */}
        </Box>
      </Container>
    </Box>
  );
};

export default HubDetailsIndex;